import { PROMOTION_TYPE, type RnbCalculatorPayload } from 'typings'
import { mapPromotionBase } from '..'
import type {
  BuyTogetherConditions,
  BuyTogetherPromotion,
  BuyTogetherRestrictions,
} from '../../../../typings'
import {
  mapBin,
  mapClusterExpressions,
  mapOrderValue,
  mapPaymentMethods,
  mapUTM,
} from '../conditions'
import {
  mapAccumulate,
  mapAccumulateWithManualPrices,
  mapBudget,
  mapMaxUsagePerClient,
  mapSalesChannels,
  mapSellerIds,
  mapUsage,
} from '../restrictions'

function mapConditions(data: RnbCalculatorPayload): BuyTogetherConditions {
  return {
    paymentMethods: mapPaymentMethods(data),
    orderValue: mapOrderValue(data),
    utm: mapUTM(data),
    cluster: mapClusterExpressions(data),
    bin: mapBin(data),
  }
}

export function mapRestrictions(
  data: RnbCalculatorPayload
): BuyTogetherRestrictions {
  return {
    maxUsage: mapUsage(data),
    maxUsagePerClient: mapMaxUsagePerClient(data),
    accumulate: mapAccumulate(data),
    accumulateWithManualPrices: mapAccumulateWithManualPrices(data),
    budget: mapBudget(data),
    sellers: mapSellerIds(data),
    salesChannels: mapSalesChannels(data),
    origin: data.origin,
  }
}

export function mapBuyTogether(
  data: RnbCalculatorPayload
): BuyTogetherPromotion {
  return {
    ...mapPromotionBase(data),
    type: PROMOTION_TYPE.BUY_TOGETHER,
    conditions: mapConditions(data),
    restrictions: mapRestrictions(data),
    buyTogether: {
      trigger: {
        skus: data.listSku1BuyTogether,
        discount: data.percentualDiscountValueList1,
        minQuantity: data.minimumQuantityBuyTogether,
      },
      benefit: {
        skus: data.listSku2BuyTogether,
        discount: data.percentualDiscountValueList2,
      },
    },
  }
}
